<template>
  <!--
      作者 luoyiming
      时间：2019-10-26
      描述：设置-商城设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">{{ $t('商城设置') }}</div>
      <el-form-item :label="$t('商城名称')" :rules="[{ required: true, message: $t('商城名称不能为空') }]" prop="name">
        <el-input v-model="form.name" :placeholder="$t('商城名称')" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item :label="$t('网址后缀英文名称')" prop="aliasName" :rules="[{ validator: validateAliasName, trigger: 'blur' }]">
        <el-input v-model="form.aliasName" :placeholder="$t('英文名称')" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item :label="$t('访问网址')">
        <ul>
          <li><span style="display: inline-block;width: 100px">{{ $t('手机网站') }}：</span>
            <a :href="website_url2"> {{ website_url2 }}</a> <span v-if="website_url2">[{{ $t('默认') }}]</span>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <a :href="website_url1"> {{ website_url1 }}</a> <span v-if="website_url1">[{{ $t('自定义') }}]</span>
          </li>
          <li><span style="display: inline-block;width: 100px">{{ $t('Pad点餐网站') }}：</span>
            <a :href="website_url3"> {{ website_url3 }}</a> <span v-if="website_url3">[{{ $t('默认') }}]</span>
          </li>

          <li><span style="display: inline-block;width: 100px">{{ $t('收银台网站') }}：</span>
            <a :href="website_url4"> {{ website_url4 }}</a> <span v-if="website_url4">[{{ $t('默认') }}]</span>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <a :href="website_url5"> {{ website_url5 }}</a> <span v-if="website_url5">[{{ $t('自定义') }}]</span>
          </li>

          <li><span style="display: inline-block;width: 100px">{{ $t('后厨网站') }}：</span>
            <a :href="website_url6"> {{ website_url6 }}</a> <span v-if="website_url6">[{{ $t('默认') }}]</span>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <a :href="website_url7"> {{ website_url7 }}</a> <span v-if="website_url7">[{{ $t('自定义') }}]</span>
          </li>
        </ul>
      </el-form-item>
      <!-- <div class="common-form">支付设置</div> -->
      <!-- <el-form-item :label="$t('支付方式')">
        <el-checkbox-group v-model="form.checkedPay">
          <el-checkbox v-for="(item,index) in pay_type" :label="item.value" :key="index">{{item.name}}</el-checkbox>
        </el-checkbox-group>
        <div class="tips">注：支付方式至少选择一个</div>
      </el-form-item> -->
      <div class="common-form">{{ $t('会员设置') }}</div>
      <el-form-item :label="$t('默认头像')" :rules="[{ required: true, message: $t('请选择默认头像') }]">
        <el-button @click="chooseImg('avatarUrl')">{{ $t('选择图片') }}</el-button>
        <img class="mt10" v-img-url="form.avatarUrl" width="200">
      </el-form-item>
      <!-- <div class="common-form">h5注册设置</div>
      <el-form-item :label="$t('是否开启短信验证')" prop="sms_open">
        <el-checkbox v-model="form.sms_open">是否开启短信验证</el-checkbox>
        <div class="tips">用户注册是否开启短信验证</div>
      </el-form-item>
      <el-form-item :label="$t('是否开启微信授权')" prop="wx_open">
        <el-checkbox v-model="form.wx_open">是否开启微信授权</el-checkbox>
        <div class="tips">用户登录是否开启微信授权</div>
      </el-form-item> -->
      <!--      <div class="common-form">日志记录</div>-->
      <!--      <el-form-item :label="$t('是否记录查询日志')" prop="is_get_log">-->
      <!--        <el-checkbox v-model="form.is_get_log">是否记录查询日志</el-checkbox>-->
      <!--        <div class="tips">如果记录，日志量会有点大</div>-->
      <!--      </el-form-item>-->
      <!--      <div class="common-form">物流查询api</div>-->
      <!--      <el-form-item label="快递100 Customer" prop="customer">-->
      <!--        <el-input v-model="form.customer" placeholder="" class="max-w460"></el-input>-->
      <!--        <div class="tips">用于查询物流信息,<el-link :underline="false" href="https://www.kuaidi100.com/openapi/" target="_blank"-->
      <!--            type="primary">快递100申请</el-link>-->
      <!--        </div>-->
      <!--      </el-form-item>-->
      <!--      <el-form-item label="快递100 Key" prop="key">-->
      <!--        <el-input v-model="form.key" placeholder="" class="max-w460"></el-input>-->
      <!--      </el-form-item>-->
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">{{ $t('提交') }}</el-button>
      </div>
    </el-form>
    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" :config="{ total: 3 }" @returnImgs="returnImgsFunc">
    </Upload>

  </div>
</template>

<script>
import SettingApi from '@/api/setting.js';
import Upload from '@/components/file/Upload';
import {
  formatModel
} from '@/utils/base.js';
export default {
  components: {
    Upload
  },
  computed: {
    website_url1() {
      if (this.form.aliasName) {
        return window.location.origin + `/${this.form.aliasName}`;
      } else {
        return '';
      }
    },
    website_url2() {
      if (this.merchant_id) {
        return window.location.origin + `/${this.merchant_id}`;
      } else {
        return '';
      }
    },
    website_url3() {
      if (this.appid) {
        return window.location.origin + `/ipad/#/?appid=${this.appid}`;
      } else {
        return '';
      }
    },

    website_url4() {
      if (this.form.aliasName) {
        return window.location.origin + `/cashier/${this.form.aliasName}`;
      } else {
        return '';
      }
    },
    website_url5() {
      if (this.merchant_id) {
        return window.location.origin + `/cashier/${this.merchant_id}`;
      } else {
        return '';
      }
    },

    website_url6() {
      if (this.form.aliasName) {
        return window.location.origin + `/kitchen/${this.form.aliasName}`;
      } else {
        return '';
      }
    },
    website_url7() {
      if (this.merchant_id) {
        return window.location.origin + `/kitchen/${this.merchant_id}`;
      } else {
        return '';
      }
    },
  },
  data() {
    return {
      appid: 0,
      merchant_id: 0,
      /*是否正在加载*/
      loading: false,
      /*form表单数据*/
      form: {
        name: '',
        aliasName: '',
        customer: '',
        key: '',
        sms_open: '',
        wx_open: '',
        is_get_log: 0,
        checkedPay: [],
        avatarUrl: '',
      },
      selectedCountry: '',
      all_type: [],
      type: [],
      pay_type: [],
      /*是否打开图片选择*/
      isupload: false,
    };
  },
  created() {
    this.getParams()
  },
  methods: {
    validateAliasName(rule, value, callback) {
      const self = this
      const regex = /^[a-zA-Z0-9]+$/; // 匹配只包含数字和英文字母的正则表达式
      if (!regex.test(value)) {
        callback(new Error(self.$t('英文名称必须只包含数字和英文字母')));
      } else {
        callback();
      }
    },
    /*获取配置数据*/
    getParams() {
      let self = this;
      SettingApi.storeDetail({}, true).then(res => {
        let vars = res.data.vars.values;
        self.form = formatModel(self.form, vars);
        self.form.customer = vars.kuaidi100.customer;
        self.form.key = vars.kuaidi100.key;
        self.form.checkedPay = vars.checkedPay;
        this.appid = res.data.app_id
        if (vars.aliasName != undefined && vars.aliasName != '') {
          self.form.aliasName = vars.aliasName
        }
        let appinfo = res.data.app
        if (appinfo.merchant_id) {
          this.merchant_id = appinfo.merchant_id
        }
        for (let i = 0; i < self.form.checkedPay.length; i++) {
          self.$set(self.form.checkedPay, i, parseInt(self.form.checkedPay[i]));
        }
        self.pay_type = res.data.pay_type;
        self.loading = false;
      })
        .catch(error => {

        });
    },
    /*提交*/
    onSubmit() {
      let self = this;
      let params = this.form;
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true;
          SettingApi.editStore(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: self.$t('恭喜你，商城设置成功'),
                type: 'success'
              });
              self.getParams()
              self.$router.push('/setting/store/index');
            })
            .catch(error => {
              self.loading = false;
            });
        } else {
          self.$message({
            message: self.$t('表单数据不符合规则'),
            type: 'warning'
          });
        }
      });
    },
    /*选择图片*/
    chooseImg(e) {
      this.type = e;
      this.isupload = true;
    },
    /*关闭选择图片*/
    returnImgsFunc(e) {
      this.isupload = false;
      if (e != null && e.length > 0) {
        if (this.type == 'logo') {
          this.form.supplier_logo = e[0].file_path;
        } else if (this.type == 'image') {
          this.form.supplier_image = e[0].file_path;
        }
      }
    }
  }

};
</script>
<style>
.tips {
  color: #ccc;
  margin-top: -5px;
  margin-left: 150px;
  margin-bottom: 30px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/settings/store/index.vue